import type { JSX } from "react";
import DataTable, { DATA_TABLE_CLASSES } from "@/components/common/DataTable";

export const SectionTable = ({
  headers,
  rows,
  emptyLabel,
}: {
  headers: string[];
  rows: (string | number | null)[][];
  emptyLabel: string;
}): JSX.Element => (
  <DataTable>
    <thead>
      <tr className={DATA_TABLE_CLASSES.headRow}>
        {headers.map((header) => (
          <th key={header} className={DATA_TABLE_CLASSES.th}>
            {header}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.length === 0 ? (
        <tr>
          <td colSpan={headers.length} className={DATA_TABLE_CLASSES.emptyCell}>
            {emptyLabel}
          </td>
        </tr>
      ) : (
        rows.map((row, idx) => (
          <tr key={idx} className={DATA_TABLE_CLASSES.bodyRow}>
            {row.map((cell, cidx) => (
              <td key={cidx} className={DATA_TABLE_CLASSES.td}>
                {cell ?? "—"}
              </td>
            ))}
          </tr>
        ))
      )}
    </tbody>
  </DataTable>
);
